export default {
  title: "Footer content",
  section_title: "Footer editor",
}
